import { useEffect, useState } from 'react';

export const useEASDataSub = ({ eventType, userId, priceAlertId }) => {
	const [response, setResponse] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		window.DDC.pubsub.subscribeOnce('mycars-nav/fetchEas', (res, err) => {
			setResponse(res);
			setError(err);
		});
	}, [eventType, userId, priceAlertId]);

	return { response, error };
};
